import { Component, Input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss'],
    imports: [MatIcon, MatTooltip],
})
export class TooltipComponent {
    @Input() text: string;
    @Input() icon: string = 'help';
    @Input() svgIcon: string;
}
